import { Separator } from 'components/common/Separator'
import { ArticlesSectionGrid } from 'components/editorial/articles/ArticlesSectionGrid'
import { ArticleCardSkeleton } from 'components/editorial/cards/ArticleCardSkeleton'
import { Fragment } from 'react'
import { range } from 'utils/arrays'

export function ArticlesSectionGridSkeleton() {
  return (
    <ArticlesSectionGrid>
      {range(0, 6).map(i => (
        <Fragment key={i}>
          <ArticleCardSkeleton />
          <Separator color='cool-300' className='last:hidden sm:hidden' />
        </Fragment>
      ))}
    </ArticlesSectionGrid>
  )
}
